<template>
  <div>
    <h2 v-if="groupedProducts && groupedProducts.length > 0" class="mb-4">Produtos desagrupados</h2>
    <component :is="getComponent" :has-segments="hasSegments" class="mt-4" :products="ungroupedProducts" />

    <div v-if="groupedProducts && groupedProducts.length > 0" class="mt-8">
      <h2 class="mb-0">Grupos de produtos</h2>

      <div v-for="group in groupedProducts" :key="group._id">
        <hr class="my-4" />
        <div class="d-flex align-center justify-space-between">
          <h2>{{ group.name }}</h2>
        </div>
        <component :is="getComponent" :has-segments="hasSegments" class="mt-4" :products="group.products" :group="group" />
      </div>
    </div>
  </div>
</template>

<script>
import AbsoluteOfferSales from './AbsoluteOfferSales.vue'
import PercentageOfferSales from './PercentageOfferSales.vue'
import TakepayOfferSales from './TakepayOfferSales.vue'
export default {
  name: 'OfferSaleTableTab',
  components: { AbsoluteOfferSales, PercentageOfferSales, TakepayOfferSales },
  props: {
    offerType: {
      type: String,
      default: '',
    },
    allProducts: {
      type: Array,
      default: () => [],
    },
    hasSegments: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({}),
  computed: {
    getComponent() {
      const components = {
        offer_sales: AbsoluteOfferSales,
        percentage_offer_sales: PercentageOfferSales,
        takepay_offer_sales: TakepayOfferSales,
      }

      return components[this.offerType]
    },
    ungroupedProducts() {
      if (!this.allProducts) return []
      return this.allProducts.filter((product) => !product.isGroup)
    },
    groupedProducts() {
      if (!this.allProducts) return []
      return this.allProducts.filter((product) => product.isGroup)
    },
  },
}
</script>

<style lang="scss" scoped>
hr {
  border: 1px solid $cinza-l60;
}

p {
  font-size: 14px;
  color: $cinza-0;
}

h2 {
  font-size: 16px;
  font-weight: 600;
  color: $cinza-d10;
}
</style>
